import Vue from 'vue'
import {mapState} from 'vuex'

Vue.mixin({
    computed: {
        isFornecedor() {
            return this.loki.user.type === null || this.loki.user.type === 'EXTERNO'
        },
        isServidorPublico() {
            return this.loki.user.type === 'INTERNO'
        },
        ...mapState(['loki'])
    }
})
